import { cachedHttp } from "./httpService";

const apiEndPoint = "/currencies";

function getCurrency(id) {
  return cachedHttp.get(`${apiEndPoint}/${id}/`);
}

export default getCurrency;
